import React, { useEffect, useState } from 'react';
import GraphButton from '../../GraphButton';
import { addNode, getOrAddNode, isNotCompoundNode, removeNode } from '../scripts/cy-core';
import { useSelector } from 'react-redux';
import { COMPOUND_BACKGROUND, COMPOUND_CONTENT } from '../scripts/cy-constant';

const BackgroundBtn = ({ cy }) => {
  let treeData = useSelector((state) => state.tree.treeData);
  let [hasBackground, setHasBackground] = useState(false);

  const onAddBackground = () => {
    const nodes = cy.nodes().filter(isNotCompoundNode);

    const bg = getOrAddNode({ id: COMPOUND_BACKGROUND, name: '' });

    const content = getOrAddNode({ id: COMPOUND_CONTENT, name: '' });

    cy.batch(function () {
      content.move({ parent: bg.id() });
      nodes.move({ parent: content.id() });
    });

    setHasBackground(true);
  };

  const onRemoveBackground = () => {
    const nodes = cy.nodes().filter(isNotCompoundNode);

    cy.batch(function () {
      nodes.move({ parent: null });
      removeNode(COMPOUND_CONTENT);
      removeNode(COMPOUND_BACKGROUND);
    });

    setHasBackground(false);
  };

  useEffect(() => {
    // const node = getNode('bg');
    if (treeData) {
      // // debug-console.log('[Use Effect] treeData=', treeData);
      if (typeof treeData === 'string') {
        treeData = JSON.parse(treeData);
      }

      const bg = treeData.filter((node) => node?.data.id === COMPOUND_BACKGROUND);

      // debug-console.log('[Use Effect] bg=', bg);
      if (bg.length > 0) {
        setHasBackground(true);
      }
    }
  }, [treeData]);

  return hasBackground ? (
    <GraphButton
      id="removeBackground"
      label="Bỏ ảnh nền"
      onClick={onRemoveBackground}
      title="Bỏ ảnh nền"
    />
  ) : (
    <GraphButton
      id="addBackground"
      label="Thêm ảnh nền"
      onClick={onAddBackground}
      title="Thêm ảnh nền"
    />
  );
};

export default BackgroundBtn;
